import React from 'react';
import { Box, Button } from '@mui/material';
import { Delete } from '@mui/icons-material';

interface DialogActionButtonsProps {
  isEncounterCancelled: boolean;
  onDelete: () => void;
  onCancel: () => void;
  onSubmit: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  isEncounterCancelled,
  onDelete,
  onCancel,
  onSubmit,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
    <Button
      onClick={onDelete}
      startIcon={<Delete />}
      disabled={isEncounterCancelled}
      sx={{
        color: isEncounterCancelled ? '#9e9e9e' : '#dc2626',
        '&:hover': {
          backgroundColor: isEncounterCancelled ? 'transparent' : '#fef2f2',
          color: isEncounterCancelled ? '#9e9e9e' : '#b91c1c'
        }
      }}
    >
      Delete
    </Button>
    <Box>
      <Button
        onClick={onCancel}
        sx={{
          color: '#64748b',
          '&:hover': {
            backgroundColor: '#f1f5f9',
            color: '#475569'
          }
        }}
      >
        {isEncounterCancelled ? 'Close' : 'Cancel'}
      </Button>
      {!isEncounterCancelled && (
        <Button
          onClick={onSubmit}
          variant="contained"
          sx={{
            backgroundColor: '#162346',
            '&:hover': {
              backgroundColor: '#1a2a52',
            },
            fontWeight: 600,
            ml: 1
          }}
        >
          Update Scheduled Procedure Code
        </Button>
      )}
    </Box>
  </Box>
);
